import { ChecklistItem } from "./checklist-item";

export class Checklist {
  id: number;
  name: string;
  description: string;
  externalCode: string;
  checklistItems: ChecklistItem[];
} 
